import { render, staticRenderFns } from "./SideTagsRecord.vue?vue&type=template&id=2c8d57fa&scoped=true&"
import script from "./SideTagsRecord.vue?vue&type=script&lang=js&"
export * from "./SideTagsRecord.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsRecord.vue?vue&type=style&index=0&id=2c8d57fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d57fa",
  null
  
)

export default component.exports